import { Select } from "antd";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
const { Option } = Select;

interface Props {
  data: any
  value: string;
  stopEditing: () => void;
  onChange?: (value: string) => void; // Optional onChange callback
  params: any;
  productList: any[]
}

interface MoodRef {
  getValue: () => string;
}

const AGProductList = forwardRef<MoodRef, Props>((props, ref) => {
  const [value, setValue] = useState<any>(props?.value ?? props?.data?.productIds);
  const refContainer = useRef<HTMLDivElement>(null);
  const [productList, setProductList] = useState<any[]>(props?.productList ?? []);

  useEffect(() => {
    if (props?.productList) {
      setProductList(props?.productList);
    }
  }, [props])

  useImperativeHandle(ref, () => ({
    getValue() {
      return value;
    },
  }));

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      setTimeout(() => {
        const target = event.target as Node;

        const clickedInsideEditor =
          refContainer.current?.contains(target);
        const clickedInsideDropdown =
          document.querySelector('.ant-select-dropdown')?.contains(target);

        if (!clickedInsideEditor && !clickedInsideDropdown) {
          props.stopEditing();
        }
      }, 0); // defer to ensure dropdown exists
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);



  return (
    <div ref={refContainer}>
      <Select
        className={"w-100"}
        defaultOpen={true}
        autoFocus={true}
        value={value}
        onChange={(value: any, obj: any) => {
          setValue(value);
          if (props.onChange) {
            props.onChange(value);
          }
        }}
        mode={'multiple'}
        maxTagCount={2}
        maxTagTextLength={5}
        maxTagPlaceholder={(omittedValues) => (
          <span>+ {omittedValues?.length} ...</span>
        )}
      >
        {productList?.map((option: any, index: any) => (
          <Option key={index} value={option.id} label={option.name}>
            {option?.name}
          </Option>
        ))}

      </Select>
    </div>
  );
});

export default AGProductList;
